export enum BuildingType {
  Catalog = 0,
  SpaceConfig = 1,
  Tracker = 2,
  Monitoring_Reporting = 3,
  Management = 4,
  Library = 5,
  Warehouse = 6,
  Marketplace = 7,
  Dummy = 8
}

